import './style.css';
import 'font-awesome/css/font-awesome.css';
import { MapContainer} from '/modules/vecdoor/oltools';
import TileLayer from 'ol/layer/Tile';
import { ModalDialog } from '/modules/vecdoor/uitools';

import OSM from 'ol/source/OSM';

import { SidePanel } from 'ol-side-panel';

//import samples from 'https://data.changegeo.com/samples/overview/samples.json' assert {type: 'json'};

//import torontoSample from './data/test/toronto.json' assert {type: 'json'};
import * as Information from './data/information';
import * as Sample from './data/sample';

let sampleInfos;
let sampleInfo;
let sampleOverview;


fetch('https://data.changegeo.com/samples/overview/samples.json')
// fetch('/data/test/workingSamples/samples.json')
    .then(response => response.json())
    .then(data => sampleInfos = data.samples)
    .then(() => setSampleInfo())
    .catch(error => pageErrorHandle('Sorry, there was an error loading sample list.', error));

function pageErrorHandle(message, error)
{
    if (sampleName) localStorage.removeItem(sampleName);

    alert(message);
    if (document.referrer) {
        window.location.href = document.referrer;
    } else {
        window.history.back();
    }

}

function createSamplesListElements()
{
    const divWrapper = document.createElement('div');
    const title = document.createElement('h2');
    divWrapper.appendChild(title);
    
    title.innerHTML = "Select a sample area:"
    sampleInfos.forEach(sample => {
        const div = document.createElement('div');
        const a = document.createElement('a');
        const url = new URL(window.location.href)
        url.searchParams.set('sampleName', sample.name);
        a.href = url.href;
        const name = document.createElement('h4');
        name.innerHTML =sample.name;
        a.appendChild(name);

        const desc = document.createElement('p');
        desc.innerHTML = sample.description;

        div.appendChild(a);
        div.appendChild(desc);
        divWrapper.append(div);
    });
    return divWrapper;
}
let sampleName = null;
function setSampleInfo()
{
    if (sampleInfos === undefined || sampleInfos.length === 0) {pageErrorHandle("Sorry, the samples did not load correctly.")}
    const url = new URL(document.URL);
    const query = url.searchParams;
    sampleName = (query.has('sampleName')) ? query.get('sampleName') : ''
    if (sampleName == '')
    {
        const infoModal = new ModalDialog();
        infoModal.open(createSamplesListElements());
        return;
    }
    sampleInfo = sampleInfos.find((info) => info.name === sampleName);

    if (sampleInfo === undefined)
    {
        sampleInfo = sampleInfos[0];
        alert(`sampleName does not exist. Using ${sampleInfo.name}`);
    }
    const localSampleInfoStr = localStorage.getItem(sampleInfo.name);
    if (localSampleInfoStr !== null) 
    {
        sampleOverview = JSON.parse(localSampleInfoStr)
        setUpDisplay();
    }
    else
    {
        fetch(sampleInfo.url)
            .then(response => response.json())
            .then(data => sampleOverview = data)
            .then(() => setUpDisplay())
            .catch(error => alert(`Error loading ${sampleName.name}: ${error}`));
    }        
}

let sample = null;
function setUpDisplay()
{
    if (sampleOverview === undefined)
    {
        alert('Error: No project defined');
        return;
    }
    sample = new Sample.Sample(sampleOverview);
    document.title = sample.name;
    const [mapLeft] = defineMaps(sample.mapInfo.getView());
    window.map = mapLeft;
    

    const sidePanel = new SidePanel();
    mapLeft.map.addControl(sidePanel);
    const infoPane = sidePanel.definePane(
    {
        paneId: 'Overview',
        name: "Overview",
        icon: '<i class="fa fa-info"></i>',
        // icon: '<i><img src="./images/irisWithSatelliteNoBackground.jpg" width="50%" ></i>',
    
    });
    
    const title = document.createElement('h2');
    title.innerHTML = sample.name;
    const description = document.createElement('p');
    description.innerHTML = sample.description;
    
    const usageDiv = document.createElement('div');
    usageDiv.innerHTML = Information.usage;
    
    const overViewDiv = document.createElement('div');
    overViewDiv.className = 'panel_div'
    
    overViewDiv.appendChild(title);
    overViewDiv.appendChild(description);
    overViewDiv.appendChild(usageDiv);
    
    infoPane.addWidgetElement(overViewDiv);
    
    sample.panes[0].definePane(sidePanel);
    
    const layersPaneSamples = sidePanel.definePane({
        paneId: 'samplesDirectory',
        name: "Samples",
        icon: '<i class="fa fa-globe"></i>',
        });
        
    const divSamples = document.createElement('div');
    divSamples.className = 'panel_div';
    divSamples.appendChild(createSamplesListElements());
    layersPaneSamples.addWidgetElement(divSamples);
        
    const layersPaneSettings = sidePanel.definePane({
    paneId: 'settings',
    name: "Settings",
    icon: '<i class="fa fa-gear"></i>',
    weight: 100
    });
    
    const div = document.createElement('div');
    div.className = 'panel_div';

    div.appendChild(getSampleDownloadElements());
    div.appendChild(resetSample());
    layersPaneSettings.addWidgetElement(div);
}

function resetSample()
{
    const div = document.createElement('div');
    const h4 = document.createElement('h4');
    h4.innerHTML = 'Reset Sample';
    const desc = document.createElement('p');
    desc.innerHTML = "Click below to clear return to the original sample settings.";
    const resetButton = document.createElement('a');
    resetButton.href = '#';
    resetButton.innerHTML = ` ${sampleInfo.name}`;
    resetButton.classList = 'fa fa-recycle';
    resetButton.addEventListener('click', (e) => 
    {
        if (sampleName) localStorage.removeItem(sampleName);
        sample=null;
        window.location.reload();
    });
    div.appendChild(h4);
    div.appendChild(resetButton);
    return div;
}

function getSampleDownloadElements()
{
    const div = document.createElement('div');
    const h4 = document.createElement('h4');
    h4.innerHTML = 'Downloads';
    const downloadButton = document.createElement('a');
    downloadButton.href = '#';
    downloadButton.innerHTML = ` ${sampleInfo.name}.json`;
    downloadButton.classList = 'fa fa-download';
    downloadButton.addEventListener('click', (e) => 
    {
        
        const link = document.createElement('a');
        updateSample();
        const blob = new Blob([JSON.stringify(sample)], {type: 'application/json'});
        link.href = URL.createObjectURL(blob);
        link.download = `${sampleInfo.name}.json`;
        link.click();
        URL.revokeObjectURL(link.href);
    })
    div.appendChild(h4);
    div.appendChild(downloadButton);
    return div;
}

function updateSample()
{
    const view = window.map.map.getView();
    sample.mapInfo.viewCenter = view.getCenter();
    sample.mapInfo.zoomLevel = view.getZoom();
}


window.addEventListener('visibilitychange', (e) =>
{
    if (sample === null) {return;}
    updateSample();
    localStorage.setItem(sampleInfo.name, JSON.stringify(sample));
});

function defineMaps(view)
{
    const mapLeft = new MapContainer("map");
    mapLeft.layerManager.addLayer(new TileLayer({ source: new OSM(), name: 'osmLayer', layerType: 'imageLayer', }));
    const sharedView = view;

    mapLeft.map.setView(sharedView);
    return [mapLeft, sharedView];
}



